import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, Mail } from 'lucide-react';
import EmailMarketing from '../../components/Admin/EmailMarketing';
import EmailLogsPage from './EmailLogsPage';

const EmailsPage = () => {
  const [activeTab, setActiveTab] = useState('marketing');

  return (
    <div className="min-h-screen py-8 px-4" data-testid="emails-page">
      <div className="max-w-7xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mb-6">
          <h1 className="text-3xl font-bold text-white mb-2">Emails</h1>
          <p className="text-[#B8B8BA] text-sm">Campagnes marketing et registre des emails envoyés</p>
        </motion.div>

        <div className="flex gap-1 mb-6 bg-[#121214] p-1 rounded-lg border border-[#3A3A3D]/40 w-fit" data-testid="email-tabs">
          <button onClick={() => setActiveTab('marketing')}
            className={`flex items-center gap-2 px-4 py-2 rounded text-sm font-medium transition-all ${activeTab === 'marketing' ? 'bg-[#FF6B35] text-black' : 'text-[#B8B8BA] hover:text-white hover:bg-[#1A1A1D]'}`} data-testid="tab-marketing">
            <Send className="h-4 w-4" />Marketing
          </button>
          <button onClick={() => setActiveTab('logs')}
            className={`flex items-center gap-2 px-4 py-2 rounded text-sm font-medium transition-all ${activeTab === 'logs' ? 'bg-[#FF6B35] text-black' : 'text-[#B8B8BA] hover:text-white hover:bg-[#1A1A1D]'}`} data-testid="tab-email-logs">
            <Mail className="h-4 w-4" />Registre Emails
          </button>
        </div>

        {activeTab === 'logs' ? (
          <EmailLogsPage />
        ) : (
          <EmailMarketing />
        )}
      </div>
    </div>
  );
};

export default EmailsPage;
